
const AboutSection = () => {
  const features = [
    {
      icon: 'ri-empathize-line',
      title: '提升自我照顧能力',
      description: '透過專業課程與活動，幫助長者維持並提升日常生活自理能力',
    },
    {
      icon: 'ri-emotion-happy-line',
      title: '快樂享受每一天',
      description: '豐富多元的活動安排，讓長者每天都充滿歡笑與期待',
    },
    {
      icon: 'ri-award-line',
      title: '尊嚴暮年幸福',
      description: '尊重每位長者的獨特性，讓他們有尊嚴地享受幸福晚年',
    },
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-baby-blue-50" aria-labelledby="about-title">
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-16">
          <div className="inline-flex items-center gap-3 bg-cream-200 px-6 py-3 rounded-full mb-6">
            <i className="ri-sun-line text-cream-600 text-xl" aria-hidden="true"></i>
            <span className="text-base font-bold text-cream-700">老大人歡樂天地</span>
          </div>

          <h2 id="about-title" className="text-3xl md:text-4xl font-bold text-baby-blue-600 mb-4 leading-tight">
            <a href="#about" className="hover:text-baby-blue-700 transition-colors">高雄市前金區日照中心服務理念</a>
          </h2>
          <p className="text-gray-500 max-w-3xl mx-auto leading-relaxed">
            <strong>前金日間照顧中心</strong>是長者的「歡樂天地」，作為<strong>高雄市前金日照推薦</strong>首選，我們相信每位長者都值得擁有快樂、有尊嚴的生活
          </p>
        </header>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <figure className="relative order-2 lg:order-1">
            <div className="relative z-10">
              <img
                src="https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/a22780e6c10575c395eabb0959f86995.jpeg"
                alt="高雄市前金區日照中心長者歡樂活動"
                title="前金日照推薦 - 長者日間照顧活動"
                loading="lazy"
                decoding="async"
                className="w-full h-[500px] object-cover object-top rounded-3xl shadow-xl"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-cream-200 rounded-3xl -z-10" aria-hidden="true"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-baby-blue-200 rounded-full -z-10" aria-hidden="true"></div>

            <figcaption className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-lg">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-cream-200 rounded-full flex-shrink-0">
                  <i className="ri-heart-3-fill text-cream-500 text-2xl" aria-hidden="true"></i>
                </div>
                <div>
                  <div className="text-lg font-bold text-baby-blue-600">用愛陪伴・快樂每一天</div>
                  <div className="text-sm text-gray-500">讓長者在高雄市前金區日照中心找到歸屬感與幸福感</div>
                </div>
              </div>
            </figcaption>
          </figure>

          <article className="order-1 lg:order-2">
            <div className="bg-gradient-to-br from-cream-100 to-baby-blue-50 rounded-3xl p-8 mb-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-cream-300 rounded-xl flex-shrink-0">
                  <i className="ri-double-quotes-l text-cream-600 text-xl" aria-hidden="true"></i>
                </div>
                <blockquote className="text-baby-blue-700 text-lg leading-relaxed italic">
                  「來到前金日照，不只是被照顧，更是來享受生活、找回自信與快樂！」
                </blockquote>
              </div>
              <p className="text-gray-600 leading-relaxed">
                我們以「老大人歡樂天地」為核心理念，打造一個讓長者能夠<strong className="text-baby-blue-600">提升自我照顧能力</strong>、<strong className="text-cream-600">快樂享受每一天</strong>，並且<strong className="text-baby-blue-600">有尊嚴地享受暮年幸福</strong>的溫馨空間。<strong>高雄市前金日照推薦</strong>選擇前金日間照顧中心。
              </p>
            </div>

            <div className="grid gap-5">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-5 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-baby-blue-100 to-cream-100 rounded-xl flex-shrink-0">
                    <i className={`${feature.icon} text-baby-blue-500 text-2xl`} aria-hidden="true"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-baby-blue-600 mb-1.5 text-lg">{feature.title}</h3>
                    <p className="text-sm text-gray-500 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
